import React, { forwardRef } from "../../__compat__/react/main.entry.mjs.mjs";
import { StyledExtension } from "./TextField.styles.mjs.mjs";
export const TextFieldExtension = (props) => React.createElement(StyledExtension, { ...props });
export const TextFieldExtensionButton = forwardRef(function TextFieldExtensionButton(props, ref) {
    return React.createElement(StyledExtension, { ref: ref, as: "button", type: "button", ...props });
});
//# sourceMappingURL=TextFieldExtension.mjs.mjs.map